import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare let AdminLTE: any;

@Component({
  standalone: false,
  selector: 'app-ajuste-plano-alterar',
  templateUrl: './ajuste-plano-alterar.component.html',
})
export class AjustePlanoAlterarComponent implements OnInit {
  
  planoTrabalhoEscolhido: any;
  celebracao: any;
  versaoPlano: any;
  planoTrabalhoHasProponente: any;

  etapa1: boolean;
  etapa2: boolean;
  etapa3: boolean;
  etapa4: boolean;
  etapa5: boolean;
  etapa6: boolean;
  etapa7: boolean;
  etapa8: boolean;
  etapa9: boolean;

  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    // Update the AdminLTE layouts
    AdminLTE.init();

    setTimeout(
      function() {
        document.getElementById("topoAlterar").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

  }

  // ==== ABRIR ETAPAS ==== //
  openEtapa1() {
    this.etapa1 = true;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa01").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/descricao-realidade']);
  }
  openEtapa2() {
   
    this.etapa1 = false;
    this.etapa2 = true;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa02").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/sintese-proposta']);
  }
  openEtapa3() {
    
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = true;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa03").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/capacidade-instalada']);
  }
  openEtapa4() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = true;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa04").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/monitoramento']);
  }
  openEtapa5() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = true;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa05").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/cronograma-fisico']);
  }
  openEtapa6() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = true;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa06").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );

    let rota = sessionStorage.getItem("rotaModuloAjuste")
    this.router.navigate([rota+'/alterar/detalhamento-financeiro']);

  }
  openEtapa7() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = true;
    this.etapa8 = false;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa07").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );
  }
  openEtapa8() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = true;
    this.etapa9 = false;

    setTimeout(
      function() {
        document.getElementById("etapa08").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );
  }
  openEtapa9() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = true;

    setTimeout(
      function() {
        document.getElementById("etapa09").scrollIntoView({
          behavior: "smooth"
        });
      }.bind(this),
      10
    );
  }
  fechaTodasEtapas() {
    this.etapa1 = false;
    this.etapa2 = false;
    this.etapa3 = false;
    this.etapa4 = false;
    this.etapa5 = false;
    this.etapa6 = false;
    this.etapa7 = false;
    this.etapa8 = false;
    this.etapa9 = false;
  }






}
